import React from 'react';
import DialogBox from '../../../core-components/theme/components/DialogBox/DialogBox';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WhatsappSmsPreviewDialogProps } from '../types/types';
import MessageBubble from './MessageBubble';

const WhatsappSmsPreviewDialog: React.FC<WhatsappSmsPreviewDialogProps> = ({ open, onClose, communication }) => {
  const { t } = useTranslation();
  return (
    <DialogBox
      open={open}
      onClose={onClose}
      title={communication.channel === 'WHATSAPP' ? 'WhatsApp' : 'SMS'}
      showCloseIcon={true}
      // minHeight="50%"
      // minWidth="50%"
      TitlefontSize="26px"
      padding="20px 20px 0px 20px"
    >
      <Box>
        <MessageBubble
          message={communication}
          isLeft={true}
          user={{
            name: communication.senderType || t('communication.unknownSender', 'Unknown Sender'),
            image: communication.profilePictureURL
          }}
          oneSideConversation={true}
        />
      </Box>
    </DialogBox>
  );
};

export default WhatsappSmsPreviewDialog;
